module.exports = __webpack_public_path__ + "static/media/11.9a95679a.jpg";